// PerformanceDashboard.tsx

import PerformanceCard from './PerformanceCard';
import { performanceDashboardConfig } from '../../config/data'

const PerformanceDashboard: React.FC = () => {
    return (
        // Outer container to simulate the blue dotted border in the screenshot
        <div className=" border-2 mt-6 ">

            <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
                {performanceDashboardConfig.map((config, index) => (
                    <PerformanceCard key={index} config={config} />
                ))}

            </div>
        </div>
    );
};

export default PerformanceDashboard;